import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { removeCookieSessionContext } from '@/utilities/setters/cookieSetters';

/**
 * localStorage keys written by Account UM for previous sessions.
 * Mirrors the legacy launcher which cleared these at boot so no stale
 * session data leaks into a fresh launch.
 */
const STALE_SESSION_KEYS = ['session-casino', 'session-sportsbook'] as const;

/**
 * Clears unusable session data left over from a previous launch.
 *
 * Fresh launches first try to hydrate a complete, non-expired cookie session.
 * This cleanup runs only when that optimistic bootstrap is unavailable, and
 * never on a soft reload (which reloads only the game-client iframe).
 */
export const clearStaleSession = (): void => {
  Logger.logRumAction({
    name: '[GW][SESSION] Clear stale session',
    useCase: DdEventCategory.Session,
    eventType: DdEventType.Action,
  });
  try {
    STALE_SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // localStorage may be unavailable (private mode / SSR) — ignore.
  }

  removeCookieSessionContext();
};
